import { Timestamp } from '@bufbuild/protobuf';
import { Code, ConnectError } from '@connectrpc/connect';
import { ContractVehicle } from '../../../../../../gen/ts/mono/datagateway/v1/delivery_pb';
import { VehicleProfile } from '../../../../../../gen/ts/mono/datagateway/v1/vehicle_identity_pb';
export const vehicleTypes = [
    'GSA_SCHEDULE',
    'GWAC',
    'BPA',
    'IDIQ',
    'MAC',
    'OTHER'
];
export function vehicleTypeLabel(value) {
    return value === 'GSA_SCHEDULE' ? 'GSA Schedule' : value === 'OTHER' ? 'Other' : value || 'Unknown';
}
export function agencyLabel(v, orgs) {
    if (!v.awardingAgencyOrgId) return `Unresolved agency${v.legacySourceAgency || v.agencyAcronym ? ` · ${v.legacySourceAgency || v.agencyAcronym}` : ''}`;
    const org = orgs.get(v.awardingAgencyOrgId);
    return `${org?.displayPath || org?.name || 'Agency unavailable'} · ${v.awardingAgencyOrgId}`;
}
export function editVehicleProfile(profile, changes, aliases = profile.aliases) {
    return new VehicleProfile({
        vehicle: new ContractVehicle({
            ...profile.vehicle,
            ...changes
        }),
        aliases
    });
}
export function dateInput(value) {
    return value?.toDate().toISOString().slice(0, 10) ?? '';
}
export function dateValue(value) {
    return value ? Timestamp.fromDate(new Date(`${value}T00:00:00Z`)) : undefined;
}
export function vehicleSaveError(error) {
    if (error instanceof ConnectError && error.code === Code.Aborted) return 'This record changed. Reload the latest record and reconcile your draft before saving.';
    if (error instanceof ConnectError && error.code === Code.AlreadyExists) return 'This identity already exists. Reload and inspect the existing record before retrying.';
    return error instanceof Error ? error.message : 'Save failed. Your draft is retained.';
}
export const orderingEligibilityOptions = [
    {
        value: 'GOVERNMENT_WIDE',
        label: 'Government-wide'
    },
    {
        value: 'AGENCY_SPECIFIC',
        label: 'Agency-specific'
    },
    {
        value: 'UNKNOWN',
        label: 'Unknown'
    }
];
export function orderingEligibilityLabel(v) {
    if (v.orderingEligibility === 'GOVERNMENT_WIDE') return 'Government-wide';
    if (v.orderingEligibility === 'AGENCY_SPECIFIC') {
        const who = v.agencyAcronym || v.legacySourceAgency;
        return who ? `${who} only` : 'Agency-specific';
    }
    return 'Unknown';
}
